<script setup lang="ts">
import type { Image } from 'sanity';
import { computed, type Component } from 'vue';
import type { LocalisedField } from '@pkg/sanity-utils/types/localisation';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    name: string,
    partnerName? : LocalisedField<string>,
    partnerLogo?: LocalisedField<Image>,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  name: props.block?.name,
  partnerName: props.block?.partnerName,
  partnerLogo: props.block?.partnerLogo,
}));

</script>

<template>
  <div class="wrapper wrapper--content">
    <component :is="props.config?.innerComponent" v-bind="data" />
  </div>
</template>